import { createFileRoute } from '@tanstack/react-router';


export const Route = createFileRoute('/app/settings/channels')({
  // eBay OAuth return contract (M17 R2CDd): the callback redirects the browser
  // back here with ?ebay=<status> (connected | error | badstate | limit) so the
  // page can toast the outcome, refresh connections, then clean the param.
  validateSearch: (search) => ({
    ebay: typeof search.ebay === 'string' ? search.ebay : undefined,
  }),
});
